import React, { useState } from "react";
import DataTable from "components/DataTable";
import PageWrapperForm from "components/PageWrapperForm";
import { useTableDataWithPost } from "hooks/useTableWithPost";
import { PlanManagerData } from "config/tableConfigs";
import PlanFormModal from "./components/PlanFormModal";
import DeleteModal from "components/DeleteModal";
import { useSession } from "hooks/useSession";

const PlanManagerPage = () => {
  const [modalShow, setModalShow]       = useState(false);
  const [modalMode, setModalMode]       = useState("add");
  const [selectedUser, setSelectedUser] = useState(null);
  const [refresh, setRefresh]           = useState(0);
  const { userid } = useSession();

  const formdata = new FormData();
  formdata.append("action", "GET");
  formdata.append("userid", userid);

  const tableData = useTableDataWithPost(
    "https://pro.mokshiq.in/plan_manager_action",
    PlanManagerData,
    formdata,
    refresh
  );

  const handleAddUser   = () => { setModalMode("add"); setSelectedUser(null); setModalShow(true); };
  const handleEditUser  = (user) => { setModalMode("edit"); setSelectedUser(user); setModalShow(true); };
  const handleDelete    = (user) => {
    setSelectedUser(user);
    setTimeout(() => {
      const el = document.getElementById("deletePlanManager");
      if (el) window.bootstrap.Modal.getOrCreateInstance(el).show();
    }, 100);
  };

  return (
    <div>
      <PageWrapperForm config={PlanManagerData} handleOnclick={handleAddUser} buttonTitle="Add Plan">
        <DataTable
          config={PlanManagerData}
          tableData={tableData}
          onEdit={handleEditUser}
          onDelete={handleDelete}
        />
      </PageWrapperForm>

      <PlanFormModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        mode={modalMode}
        userData={selectedUser}
        onSuccess={() => { setRefresh(p => p + 1); setModalShow(false); }}
      />

      <DeleteModal
deleteid={selectedUser?.id}
        id="deletePlanManager"
        title="Delete Plan"
        message="Are you sure you want to delete this plan?"
        apiUrl="https://pro.mokshiq.in/plan_manager_action"
        onSuccess={() => setRefresh(p => p + 1)}
      />
    </div>
  );
};

export default PlanManagerPage;